module.exports = __webpack_public_path__ + "img/dailyreportTxt.5a513a56.png";